import {
  METRICS_INTERVAL_CONFIG,
  MetricsInterval,
} from 'src/containers/metrics/constants';
import { ScoringHealthResponse } from 'src/containers/metrics/types';

import { serializeQueryParameters } from './helpers';
import { monitoringAPI } from './monitoring';

const MAX_SCORING_RANGE_MS = 31 * 24 * 60 * 60 * 1000 - 60 * 1000;

export const getScoringTimeseriesRange = (interval: MetricsInterval) => {
  const { lookbackMs, periodMs } = METRICS_INTERVAL_CONFIG[interval];
  const to = new Date();
  const from = new Date(
    to.getTime() - Math.min(lookbackMs, MAX_SCORING_RANGE_MS)
  );

  return {
    from: from.toISOString(),
    to: to.toISOString(),
    step: Math.round(periodMs / 1000),
  };
};

export const fetchScoringTimeseriesByInstance = async (
  interval: MetricsInterval
): Promise<ScoringHealthResponse> => {
  const { data } = await monitoringAPI.get<ScoringHealthResponse>(
    `/scoring/timeseries/by-instance${serializeQueryParameters(
      getScoringTimeseriesRange(interval)
    )}`
  );

  return data;
};
